import AuthLayout from '@/app/layout/authLayout'
import { RegistrationForm } from '@/app/entities/auth/ui/registration/RegistrationForm'

export const RegistrationPage = () => {
    return (
        <AuthLayout>
            <RegistrationForm />
        </AuthLayout>
    )
}
